import React from 'react';
import PropTypes from 'prop-types';

import {
  SERVICE_FOR_TYPE_MY_CLIENT,
  SERVICE_FOR_TYPE_MYSELF,
  SERVICE_FOR_TYPE_SOMEONE_I_CARE_FOR
} from '../../../constants';
import MultiChoiceSelection from '../../components/MultiChoiceSelection';


const ServiceFor = ({ value, onChange, setPagename, nextPage }) => {

  const serviceForTypes = [
    SERVICE_FOR_TYPE_MYSELF,
    SERVICE_FOR_TYPE_SOMEONE_I_CARE_FOR,
    SERVICE_FOR_TYPE_MY_CLIENT,
  ];

  const handleGoNextPageOnClick = () => {
    setPagename(nextPage.name);
  };

  const handleOnChange = values => {
    onChange(values[0]);
  };

  return (
    <MultiChoiceSelection
      data={serviceForTypes}
      selectedValues={value ? [value] : []}
      onChange={handleOnChange}
      isSingleChoice={true}
      handleSingleChoiceClick={handleGoNextPageOnClick}
    />
  );
};

ServiceFor.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  setPagename: PropTypes.func,
  nextPage: PropTypes.object,
};

export default ServiceFor;